<template>
  <mapit-dialog
    :dialog="isDialogOpen"
    @close="$emit('onClose')"
    class="create-offer-dialog"
    customId="create-offer-dialog"
    style="overflow-y: inherit">
    <template v-slot:header-text>
      <h3 class="create-offer-dialog__title">{{ $t('title.create-offer') }}</h3>
    </template>
    <template v-slot:body v-if="isDialogOpen">
      <init-offer-client-history />
    </template>
  </mapit-dialog>
</template>
<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import MapitDialog from '@/components/dialog/MapitDialog.vue'
import InitOfferClientHistory from '@/components/offer-manager/InitOfferClientHistory.vue'

export default defineComponent({
  name: 'CreateOfferDialog',
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: {MapitDialog, InitOfferClientHistory},
})
</script>
<style lang="scss">
.create-offer-dialog {
  padding: 20px 32px !important;
  height: 550px;

  &__title {
    padding-bottom: 16px;
    border-bottom: 1px solid #c0c0c0;
  }
}
</style>
